// extracted by mini-css-extract-plugin
module.exports = {"FullscreenImage":"FullscreenImage_FullscreenImage__UZtU8"};